var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image && _vm.placement)?_c('div',{staticClass:"root",class:{
    'root-prominent': _vm.placement === 'prominent',
    'root-float-left': _vm.placement === 'float-left',
    'root-float-right': _vm.placement === 'float-right'
  }},[_c('div',{staticClass:"content",class:{
      'content-prominent': _vm.placement === 'prominent',
      'content-full-width': _vm.placement === 'full-width',
    }},[_c('img',{staticClass:"image",class:{
        'image-float-left': _vm.placement === 'float-left',
        'image-float-right': _vm.placement === 'float-right',
        'image-prominent': _vm.placement === 'prominent',
        'image-full-width': _vm.placement === 'full-width'
      },style:(_vm.imageStyles),attrs:{"src":_vm.urlFor(_vm.image).width(_vm.imageSize.width).url(),"alt":_vm.description}}),(_vm.showImageGutter)?_c('div',{staticClass:"gutter",class:{
        'gutter-float-left': _vm.placement === 'float-left',
        'gutter-float-right': _vm.placement === 'float-right',
        'gutter-prominent': _vm.placement === 'prominent',
        'gutter-full-width': _vm.placement === 'full-width'
      }},[_c('p',{staticClass:"description"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s((_vm.title + ". ")))]),_vm._v(" "+_vm._s(_vm.description)+" ")])]):_vm._e()])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }